import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, of, switchMap } from 'rxjs';
import { Config } from 'src/app/app-constant';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { calculateFiscalYear, formatYearRanges, strictEmailValidator } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-convert-elcm-popup',
  templateUrl: './convert-elcm-popup.component.html',
  styleUrls: ['./convert-elcm-popup.component.scss'],
})
export class ConvertElcmPopupComponent implements OnInit {
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYearForCompetency: any;
  pmsYears: any;
  canadidateData: any;
  condidateForm!: FormGroup;
  isManual: boolean = false;
  addSubmitForm: boolean = false;
  loggedInUserCompanyName: any
  allCandidateList: any = [];
  checkCompanyCode: any;
  constructor(private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public candidate: any,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private loader: LoaderService,
    private encryptionService: EncryptionService,

    public dialogRef: MatDialogRef<ConvertElcmPopupComponent>,
  ) {

    this.canadidateData = candidate.candidateData;
    this.allCandidateList = candidate.allCandidateList



    this.condidateForm = this.fb.group({
      employeeCode: ['', this.employeeCodeValidator.bind(this)],
      employeeCodeCreate: [''],
      mail: ['', [Validators.required, Validators.email,strictEmailValidator]],
    });
  }
employeeCodeValidator(control: FormControl) {
  const value = control.value;

  if (this.isManual) {
    // Required check
    if (!value) {
      return { required: true };
    }

    // Starts with special character check
    const startsWithSpecialChar = /^[^a-zA-Z0-9]/.test(value);
    if (startsWithSpecialChar) {
      return { startsWithSpecialChar: true };
    }

    // Max length check
    if (value.length > 255) {
      return { maxLengthExceeded: true };
    }
  }

  return null;
}


  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserCompanyName = sessionStorage.getItem('loggedInUserCompanyName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getpmsyearlist();
    this.httpService.employeeCodeData$.subscribe((data: any) => {
      console.log(data);
      this.isManual = data?.isManual;
      this.checkCompanyCode = data;


    });
  }
  hasError(controlName: any, errorType: any) {
    const control = this.condidateForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.getEmployeeListCode();
      this.getCompanyDataByCompID();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }
  employeeData: any = [];
  departmentCode: any;
  locationCode: any


  getEmployeeListCode() {

    this.httpService.callGetService(`${this.config.eployeeCodeList}?companyId=${this.loggedInUserCompanyID}&candidateId=${this.canadidateData.candidateId}&year=${this.selectedYearForCompetency}`).subscribe((record: any) => {
      this.employeeData = record.data;
      console.log(this.employeeData);
      console.log(this.allCandidateList);
      console.log(this.isManual);

      let approvedCandidates = this.allCandidateList.filter((elm: any) => elm.status === 'APPROVED_APPOINTMENT_LETTER');



      const lastObject = this.employeeData[0];


      // let FinalCode = lastObject?.prefix + lastObject?.departmentCode + (lastObject?.startNumber+approvedCandidates.length) + lastObject?.locationCode;
      // Convert startNumber to a number, add the approved candidates count,
      // then convert back to a string with the same length as the original (e.g., 3 digits)
      const startNum = parseInt(lastObject.startNumber, 10);
      const nextStartNumber = (startNum + approvedCandidates.length)
        .toString()
        .padStart(lastObject.startNumber.length, '0');

      // let FinalCode = lastObject.prefix + lastObject.departmentCode + nextStartNumber + lastObject.locationCode;
      let FinalCode = '';
      if (nextStartNumber) {
        this.departmentCode = lastObject.departmentCode;
        this.locationCode = lastObject.locationCode;
        console.log(this.departmentCode);
        console.log(this.locationCode);

        FinalCode = (lastObject.prefix ?? '') + (lastObject.departmentCode ?? '') + nextStartNumber + (lastObject.locationCode ?? '');
      } else {
        this.departmentCode = lastObject.departmentCode;
        this.locationCode = lastObject.locationCode;
        console.log(this.departmentCode);
        console.log(this.locationCode);
        FinalCode = (lastObject.prefix ?? '') + lastObject.departmentCode || '' + lastObject.startNumber + (lastObject.locationCode ?? '');
      }

      console.log(FinalCode);
      console.log(this.canadidateData.candidateId);

      let currentEmployeeMAil = this.allCandidateList.filter((elm: any) => elm.candidateId == this.canadidateData.candidateId);

      console.log(currentEmployeeMAil);

      if (!this.isManual) {

        // mail: currentEmployeeMAil[0]?.candidateEmail
        this.condidateForm.patchValue({
          employeeCodeCreate: FinalCode,
        });
      }
    })
  }

  emailOfHrAdmin: any;
  checkHRName: any;
  hrID:any;
  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {

      console.log(data?.data);
      this.checkHRName = data?.data.firstnameOfHrAdmin +" " + data?.data.lastnameOfHrAdmin
      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;
this.hrID=data?.data?.companyHrId;


    })
  }
  isLoading: boolean = false;
 
  savecandidatedata() {
    if (this.isLoading) {
      return; // Prevent multiple API calls
    }

    console.log(this.condidateForm.value);

    if (this.condidateForm.invalid) {
      this.addSubmitForm = true;
      this.condidateForm.markAllAsTouched();
      return;
    }

    // let formData = {
    //   officialEmail: this.condidateForm.value.mail,
    //   candidateId: this.canadidateData.candidateId,
    //   companyName: this.loggedInUserCompanyName,
    //   finalCode: this.condidateForm.value.employeeCode || null,
    //   companyId: this.loggedInUserCompanyID,
    //   year: this.canadidateData.year
    // };

console.log( this.condidateForm.value);

    let convertFromData = {


      officialEmail: this.condidateForm.value.mail,
      candidateId: this.canadidateData.candidateId,
      companyName: this.loggedInUserCompanyName,
      finalCode: this.condidateForm.value.employeeCode ? this.condidateForm.value.employeeCode 
      :(this.locationCode==null && this.departmentCode == null) ? this.condidateForm.value?.employeeCodeCreate:null,
      companyId: this.loggedInUserCompanyID,
      year: this.canadidateData.year,
      finalCodeByLocation: (this.locationCode && this.departmentCode == null) ? this.condidateForm.value.employeeCodeCreate : null,
      finalCodeByDepartment: (this.departmentCode && this.locationCode == null) ? this.condidateForm.value.employeeCodeCreate : null,
      finalCodeByDepartmentAndLocation: (this.departmentCode !== null && this.locationCode !== null) ? this.condidateForm.value.employeeCodeCreate : null,


    }

    let formDataForAppoinment = {
      candidateId: this.canadidateData.candidateId,
      hrEmail: this.emailOfHrAdmin,
      companyId: this.loggedInUserCompanyID,
      finalEmployeeCode: this.condidateForm.value.employeeCode ? this.condidateForm.value.employeeCode : this.condidateForm.value?.employeeCodeCreate,
      isAppointmentletter: "Yes",
      year: this.canadidateData.year
    };

    this.isLoading = true;
    this.isLoading = true; // Set API call flag

    this.httpService.callPostService(`${this.config.viewOfferLetter}`, formDataForAppoinment)
      .pipe(
        switchMap((record1: any) => record1 ? this.httpService.callPostService(`${this.config.updateSalaryBreckup}`, formDataForAppoinment) : of(null)),
        switchMap((record2: any) => record2 ? this.httpService.callPostService(`${this.config.convertCandidateToEmployee}`, convertFromData) : of(null)),
        finalize(() => {
          this.isLoading = false;
          this.isLoading = false; // Reset API call flag
        }),
        catchError((error: any) => {

          this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.message,
              btn2: 'OK',
              btn2BgColor: 'red',
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
          this.isLoading = false;
          this.isLoading = false;
          return of(null);
        })
      )
      .subscribe((finalRecord: any) => {
        if (finalRecord) {

          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            // height: '25%',
            // width: '30%',
            data: {
              msg: finalRecord.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {


            
            this.dialogRef.close();
          });
        }
      });
  }


  cancelbutton() {
    this.dialogRef.close()
  }
}
